/**
 * Advanced example demonstrating all core MobX constructs.
 */
import { makeAutoObservable } from "mobx";

class VaultStore {
  // ====================================================
  // State
  // ====================================================
  user = null;
  count = 0;
  error = null;

  numberOfPackages = null;
  payingAll = false;
  paymentType = null;
  exactTrip = {
    trip: null,
    savingFrequency: null,
  };
  modalType = null;
  showModal = false;
  paying = false;
  couponCode = " ";

  currentAccount = null;

  constructor() {
    makeAutoObservable(this);
  }

  setPackageNumber = (number) => {
    this.numberOfPackages = number;
  };
  setPaying = (state) => {
    this.payingAll = state;
  };
  updateProfileInfo = (profileInfo) => {
    this.loadingMe = true;
    this.me = profileInfo;
    this.loadingMe = false;
  };
  setExactTrip = (trip) => {
    this.exactTrip.trip = trip;
  };

  setModalType = (type) => {
    this.modalType = type;
  };

  setPaymentType = (type) => {
    this.paymentType = type;
  };

  setShowModal = (state) => {
    this.showModal = state;
  };

  updateCurrentAccount = (info) => {
    this.currentAccount = info;
  };

  setPaymentCouponCode = (code) => {
    this.couponCode = code;
  };

  // Drops the previous user's account/vault data on logout / account switch
  // so it can't leak into the next session before fresh data loads. Mirrors
  // every field's class-default initial value.
  reset = () => {
    this.currentAccount = null;
    this.numberOfPackages = null;
    this.payingAll = false;
    this.paymentType = null;
    this.exactTrip = {
      trip: null,
      savingFrequency: null,
    };
    this.modalType = null;
    this.showModal = false;
    this.paying = false;
    this.couponCode = " ";
  };
}

export default new VaultStore();
